<div>
  <div class="invoice-container">
    <div class="invoice-header">
      {{ partner.partnerName }}
    </div>
    <div class="invoice-header margin-bottom-16">
      #{{jobcard}}
    </div>
    <div *ngFor="let lineItem of lineItems">
      <div class="lineItem">
        <div>
          {{lineItem.quantity}} * {{lineItem.description}}
          <div *ngIf="lineItem.lineItemNote" style="font-size: 90%;opacity: 0.8;">*{{lineItem.lineItemNote}}</div>
        </div>
        <div>
          {{currency}}{{lineItem.amount}}
        </div>
      </div>
    </div>
    <div class="lineItem margin-top-8">
      <div>
        {{"bikeshop.products.excl_vat" | translate}}
      </div>
      <div>
        {{currency}}{{excluding | number : '.2-2'}}
      </div>
    </div>
    <div class="lineItem" *ngIf="helpersService.showTaxRow(tax, partner)">
      <div>
        {{ "bikeshop.print.tax" | translate}}
      </div>
      <div>
        {{currency}}{{tax | number : '.2-2'}}
      </div>
    </div>
    <div class="lineItem">
      <div>
        {{ "bikeshop.modal.update_job_card.quote.total" | translate}}
      </div>
      <div>
        {{currency}} {{total | number : '.2-2'}}
      </div>
    </div>
  </div>
  <div class="cell example example1 margin-top-16" id="example-1">
    <form id="payment-form">
      <fieldset>
        <div class="row">
          <div id="example1-card"></div>
          <div id="card-errors" role="alert"></div>
        </div>
      </fieldset>
    </form>
  </div>
  <button [disabled]="loading" id="submit_button" (click)="submitPayment()">
    <div *ngIf="loading">
      {{'cyclist.processing' | translate }}...
    </div>
    <div *ngIf="!loading">
      {{ "bikeshop.account.submit_payment" | translate }}
    </div>
  </button>
</div>

